import React from 'react';
import PageWrapper from './PageWrapper';
import BwSignature from './BwSignature';
import { heights, widths } from './../styles/theme.json';

const PageLoader = () => {
  return (
    <PageWrapper>
      <section id={'loader-content'}>
        <h1 className={'loader-logo'}>Bruce Weber</h1>
      </section>
      <style jsx>{`
        @keyframes pulse {
          0% {
            opacity: 0;
          }
          15% {
            opacity: .25;
          }
          50% {
            opacity: 1;
          }
          90% {
            opacity: .25;
          }
          100% {
            opacity: 0;
          }
        }
        #loader-content {
          height: 100vh;
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          position: fixed;
          top: 0;
          left: 0;
          padding-bottom: 2vh;
        }
        .loader-logo {
          animation: pulse 5000ms infinite linear;
          font-family: mallory,arial;
          font-weight: 700;
          text-transform: uppercase;
          font-size: 1.4rem;
          letter-spacing: .15rem;
        }

      `}</style>
    </PageWrapper>
  );
};

export default PageLoader;



// WEBPACK FOOTER //
// ./src/components/PageLoader.js